module.exports = __webpack_public_path__ + "static/media/health-medical-reimbursement.cbb269a9.svg";